export default (value, el) => {
  if (!value || !el) {
    return true
  }
  return value.length <= el.getAttribute('maxlength')
}
